import * as ActionTypes from 'state/types'
import Routes from 'shared/utils/api/routes'

export const fetchCounters = () => (
  {
    type: ActionTypes.COUNTERS_LIST_REQUEST,
    payload: {
      url: Routes.INTERACTIONS_COUNTERS_LIST_ROUTE,
      method: 'get'
    }
  }
)

export const countersUpdated = (payload) => (
  {
    type: ActionTypes.COUNTERS_UPDATED,
    payload
  }

)